import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'element-ui/lib/theme-chalk/base.css'
import {
  Button,
  Card,
  Col,
  Container,
  DatePicker,
  Descriptions,
  DescriptionsItem,
  Dialog,
  Divider,
  Empty,
  Form,
  FormItem,
  Header,
  Input,
  InputNumber,
  Loading,
  Main,
  Menu,
  MenuItem,
  Option,
  Pagination,
  Progress,
  Row,
  Select,
  Switch,
  Aside,
  Table,
  TableColumn,
  Tabs,
  TabPane,
  Tag,
  TimePicker,
  Upload
} from 'element-ui'
import { Message, MessageBox } from 'element-ui'
import axios from 'axios'

Vue.config.productionTip = false

// ElementUI 按需加载（降低 chunk-vendors 体积）
Vue.use(Button)
Vue.use(Card)
Vue.use(Col)
Vue.use(Container)
Vue.use(DatePicker)
Vue.use(Descriptions)
Vue.use(DescriptionsItem)
Vue.use(Dialog)
Vue.use(Divider)
Vue.use(Empty)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Header)
Vue.use(Input)
Vue.use(InputNumber)
Vue.use(Main)
Vue.use(Menu)
Vue.use(MenuItem)
Vue.use(Option)
Vue.use(Pagination)
Vue.use(Progress)
Vue.use(Row)
Vue.use(Select)
Vue.use(Switch)
Vue.use(Aside)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Tag)
Vue.use(TimePicker)
Vue.use(Upload)
Vue.use(Loading.directive)

Vue.prototype.$loading = Loading.service
Vue.prototype.$message = Message
Vue.prototype.$confirm = MessageBox.confirm
Vue.prototype.$alert = MessageBox.alert

function parseJwtPayload(token) {
  try {
    const parts = (token || '').split('.')
    if (parts.length < 2) return null
    let base64 = parts[1].replace(/-/g, '+').replace(/_/g, '/')
    while (base64.length % 4 !== 0) base64 += '='
    const json = decodeURIComponent(
      atob(base64)
        .split('')
        .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    )
    return JSON.parse(json)
  } catch (e) {
    return null
  }
}

function isJwtExpired(token) {
  const payload = parseJwtPayload(token)
  if (!payload || !payload.exp) return false
  const nowSec = Math.floor(Date.now() / 1000)
  return payload.exp <= (nowSec + 5)
}

function forceLogoutToLogin() {
  localStorage.removeItem('token')
  // 避免重复跳转
  if (router.currentRoute && router.currentRoute.path === '/login') return
  router.push('/login')
}

// 配置axios
axios.defaults.baseURL = '/api'
axios.interceptors.request.use(config => {
  const token = localStorage.getItem('token')
  if (token) {
    if (isJwtExpired(token)) {
      // 登录超时：不再继续带 token 请求，直接退出到登录
      forceLogoutToLogin()
      return Promise.reject(new Error('登录已超时'))
    }
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

axios.interceptors.response.use(
  response => {
    // 兼容后端统一返回 Result：业务码 401/403 也视为登录超时/无权限
    const d = response && response.data
    if (d && (d.code === 401 || d.code === 403)) {
      forceLogoutToLogin()
      return Promise.reject(new Error(d.message || '登录已超时'))
    }
    return response
  },
  error => {
    if (error.response && (error.response.status === 401 || error.response.status === 403)) {
      forceLogoutToLogin()
    }
    return Promise.reject(error)
  }
)

Vue.prototype.$axios = axios

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
